<!-- <mat-button-toggle-group [value]="selectedComponent" (change)="onToggleChange($event.value)" class="toggle-button">
  <mat-button-toggle value="select">Bewertungen auswählen</mat-button-toggle>
  <mat-button-toggle value="order">Bewertungen ordnen</mat-button-toggle>
</mat-button-toggle-group> -->

@if (selectedComponent === reviewMode.Select) {
    <app-website-config-reviews-select (reviewModeChange)="onToggleChange($event)" [@fadeInOut]></app-website-config-reviews-select>
} @else if (selectedComponent === reviewMode.Order) {
    <app-website-config-reviews-order (reviewModeChange)="onToggleChange($event)" [@fadeInOut]></app-website-config-reviews-order>
}